import { useContext } from 'react';
import AuthContext from '../contexts/AuthContext';
import AdminDashboard from './AdminDashboard';
import UserDashboard from './UserDashboard';
import { Navigate } from 'react-router-dom';
import { URole } from '../constants/navigation';

const Dashboard = () => {
  const { userData } = useContext(AuthContext);

  if (userData?.role === URole.COMPANY_ADMIN)
    return <Navigate to="/token-management" replace />;

  return <Navigate to="/wallet" replace />;
};

export default Dashboard;
